import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { OrganizationSimple } from '../OrganizationSimple.js';
import { STInvoice } from './STInvoice.js';
import { STInvoiceMeta } from './STInvoiceMeta.js';
export class STPendingInvoice extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.id = null;
        this.invoice = null;
        this.createdAt = null;
        this.updatedAt = null;
    }
}
__decorate([
    field({ decoder: StringDecoder, nullable: true, optional: true })
], STPendingInvoice.prototype, "id", void 0);
__decorate([
    field({ decoder: STInvoiceMeta })
], STPendingInvoice.prototype, "meta", void 0);
__decorate([
    field({ decoder: STInvoice, nullable: true })
], STPendingInvoice.prototype, "invoice", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], STPendingInvoice.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], STPendingInvoice.prototype, "updatedAt", void 0);
export class STPendingInvoicePrivate extends STPendingInvoice {
}
__decorate([
    field({ decoder: OrganizationSimple, optional: true })
], STPendingInvoicePrivate.prototype, "organization", void 0);
//# sourceMappingURL=STPendingInvoice.js.map